import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetSelfServiceScheduleParams } from '../../../ts/ServerApi/types/actionParams';

export class SetSubscriptionsSelfServiceScheduleRequest extends Request<ISetSelfServiceScheduleParams, IResult> {
  constructor(params: ISetSelfServiceScheduleParams) {
    super('setSubscriptionsSelfServiceSchedule', params);
  }
}
